import { graphql } from 'relay-runtime';

export const focusMembership = graphql`
  query FocusMembershipQuery($classId: ID!, $validCurrentRoadmapsOnly: Boolean = true) {
    class(classId: $classId) {
      id
      users {
        id
        isActive
        roles {
          name
        }
        studentTargetGroups(validCurrentRoadmapsOnly: $validCurrentRoadmapsOnly) {
          isCurrent
          targetGroup {
            id
            name
          }
        }
      }
    }
  }
`;

export const focusRoadmapSkills = graphql`
  query FocusRoadmapSkillsQuery($targetGroupId: Int!) {
    targetGroup(targetGroupId: $targetGroupId) {
      id
      targets(filter: { isActive: ACTIVE }) {
        id
        targetSkills {
          targetSkillType {
            name
          }
          skill {
            id
          }
        }
      }
    }
  }
`;

export const focusUnit = graphql`
  query FocusUnitQuery($targetId: ID!) {
    target(targetId: $targetId, filter: { isActive: ACTIVE }, targetGroupFilter: { isActive: BOTH }) {
      id
      name
      targetGroup {
        name
      }
      targetSkills {
        targetSkillType {
          name
        }
        skill {
          id
        }
      }
    }
  }
`;
